import {
  RequestAccessController,
  useRequestDependencies,
  useRequestPersistedStore,
  useRequestStore,
} from "entities/Request";
import { memo, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { Loader } from "ui";
import { useCardRequest } from "../api/hooks/useCardRequest";
import CardStatementDetails from "../components/CardStatementDetails/CardStatementDetails";
import { useCostLinesStore } from "entities/CostLines";

const access = new RequestAccessController();

function CardStatementDetailsWithPermissions({ cardFormat }) {
  const { number } = useParams();
  const [searchParams] = useSearchParams();
  const viewRequestAs = useRequestPersistedStore(
    (state) => state.viewRequestAs
  );
  const setViewRequestAs = useRequestPersistedStore(
    (state) => state.setViewRequestAs
  );
  const request = useRequestStore((state) => state.request);
  const setRequest = useRequestStore((state) => state.setRequest);
  useEffect(() => {
    setViewRequestAs({ role: searchParams.get("role") || viewRequestAs.role });
  }, [searchParams]);

  const { data: requestData, isLoading: isLoadingRequest } = useCardRequest(
    number,
    searchParams.get("role") || viewRequestAs.role
  );

  useEffect(() => {
    if (requestData) {
      setRequest(requestData);
    }
    return () => {
      setRequest(null);
      useCostLinesStore.setState({ costLinesState: {} });
    };
  }, [requestData]);

  const {
    data: {
      dependencies: basicDetailsDependencies,
      validations: basicDetailsValidations,
    } = {},
    isLoading: isLoadingBasicDetailsDependencies,
  } = useRequestDependencies("base_application_form", request?.id, {
    triggerRequest: access.to("BasicDetails", "edit").provided(),
  });

  const { isLoading: isLoadingRequestDependencies } = useRequestDependencies(
    "credit_cards_form_dependencies",
    request?.id,
    {
      triggerRequest: access.to("SubCosts", "edit").provided(),
    }
  );

  if (
    !request ||
    isLoadingRequest ||
    isLoadingBasicDetailsDependencies ||
    isLoadingRequestDependencies
  ) {
    return (
      <Loader
        variant="primary"
        size="md"
        className="position-absolute top-50 vw-100 justify-content-center"
      >
        Getting your card expenses...
      </Loader>
    );
  }

  return (
    <CardStatementDetails
      cardFormat={cardFormat}
      basicDetailsDependencies={basicDetailsDependencies}
      basicDetailsValidations={basicDetailsValidations}
    />
  );
}

export default memo(CardStatementDetailsWithPermissions);
